import { useEffect } from "react";
import { useDispatch } from "react-redux";
import SubMenu from "../../comm/SubMenu";
import SubBanner from "../../comm/SubBanner";
import PdfPage from "../../comm/PdfPage";
import { fnFileDownload } from "../../../js/util";

function Articles({ props }) {
  const dispatch = useDispatch();

  useEffect(
    () => {
      dispatch({
        type: "pageChange",
        payload: { sub01: "조합소개", sub02: "조합정관 및 사업자윤리강령" },
      });

      setTimeout(() => {
        dispatch({ type: "loadingChange", payload: false });
      }, 500);
    },
    // eslint-disable-next-line
    []
  );

  return (
    <>
      <SubBanner id="intro" />

      <section className="admin section">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <div className="row">
                <div className="col-12">
                  <h2>조합정관 및 사업자윤리강령</h2>
                  <span>
                    조합의 기본 원칙과 윤리적 경영을 담당하는 핵심 규정을
                    소개합니다.
                  </span>
                </div>
              </div>

              <div className="container pt-20 pb-20">
                <div className="row round-box">
                  <div className="col-12">
                    <div className="row pb-10">
                      <div className="col-12 mb-30">
                        <h5 className="sub-title">
                          정관&nbsp;
                          <i
                            className="icofont-diskette"
                            title="정관 다운로드"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              fnFileDownload("./doc/정관.pdf", "정관.pdf")
                            }
                          />
                        </h5>
                      </div>

                      <div className="col-12">
                        <div className="all-page-container">
                          <PdfPage pdf="./doc/정관.pdf" width="1000" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="container pb-20">
                <div className="row round-box">
                  <div className="col-12">
                    <div className="row mb-30">
                      <div className="col-12">
                        <h5 className="sub-title">
                          자동차 정비사업자 윤리강령&nbsp;
                        </h5>
                      </div>
                    </div>
                    <div className="row mb-3 d-flex align-items-center">
                      <div className="col-12 col-md-3 text-center mb-3 mb-md-0">
                        <span className="bg-article-title">사회적 책임</span>
                      </div>
                      <div className="col-12 col-md-9">
                        우리는 고귀한 생명과 재산을 보호하여 정비 사업의 사회적
                        책임을 다한다.
                      </div>
                    </div>
                    <div className="row mb-3 d-flex align-items-center">
                      <div className="col-12 col-md-3 text-center mb-3 mb-md-0">
                        <span className="bg-article-title">건전한 발전</span>
                      </div>
                      <div className="col-12 col-md-9">
                        우리는 질서의식과 준법정신으로 정비 사업의 건전한 발전을
                        도모한다.
                      </div>
                    </div>
                    <div className="row d-flex align-items-center">
                      <div className="col-12 col-md-3 text-center mb-3 mb-md-0">
                        <span className="bg-article-title">사업 현대화</span>
                      </div>
                      <div className="col-12 col-md-9">
                        우리는 생산성 향상과 경영합리화로 정비 사업의 현대화를
                        이룩한다.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <SubMenu id="intro" />
          </div>
        </div>
      </section>
    </>
  );
}

export default Articles;
